import { Button, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React, { Fragment } from 'react';

export interface ConfirmModalProperties {
  title: string;
  text: React.ReactNode;
  onOk?: () => Promise<void>;
  onCancel?: () => Promise<void>;
}

export const ConfirmModal = ({ title, text, onOk, onCancel = async () => {} }: ConfirmModalProperties) => {
  return (
    <Fragment>
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{text}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onCancel}>
          Отменить
        </Button>
        <Button variant="contained" color="primary" onClick={onOk} autoFocus>
          Да
        </Button>
      </DialogActions>
    </Fragment>
  );
};
